<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="justify-end align-end text-end">
        <v-btn color="white" @click="showModal">
          <v-icon class="grey--text">mdi-plus</v-icon>
          <themed-title title="Upload Contacts"/>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog v-model="dialog" width="600">
        <v-form>
          <v-card>
            <v-card-title class="justify-center">
              <themed-title title="Upload Contacts"/>
            </v-card-title>
            <v-card-text>
              <v-file-input
                  v-model="files"
                  accept=".xls,.csv,.xlsx"
                  color="deep-purple accent-4"
                  counter
                  label="Upload Excel files"
                  placeholder="Select your files"
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
              >
                <template v-slot:selection="{ index, text }">
                  <v-chip
                      v-if="index < 2"
                      color="deep-purple accent-4"
                      dark
                      label
                      small
                  >
                    {{ text }}
                  </v-chip>

                  <span
                      v-else-if="index === 2"
                      class="text-overline grey--text text--darken-3 mx-2"
                  >
        +{{ files.length - 2 }} File(s)
      </span>
                </template>
              </v-file-input>
              <!--              <v-file-input chips small-chips outlined dense accept=".xls,.csv,.xlsx" multiple label="Upload excel sheets"/>-->
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn color="white" @click="uploadContacts">
                <themed-title title="Upload Contacts"/>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>
    <v-row>
      <v-col cols="12">
        <table-widget title="App Contacts" :headers="headers" :table-row-data="sms"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TableWidget from "@/components/widgets/tables/TableWidget";
import SmsCampaignForm from "@/components/widgets/forms/smsCampaignForm";
import {getRequest, postRequest} from "@/api/apirepository";
import ThemedTitle from "@/components/widgets/themedTitle";
import httpClient from "@/api/api";

export default {
  name: "Contacts",
  components: {ThemedTitle, SmsCampaignForm, TableWidget},
  data() {
    return {
      headers: [
        {
          text: 'County',
          align: 'left',
          sortable: true,
          value: 'orderRef',
        },
        {text: 'Members', value: 'vehicle'},
        {text: 'Actions', value: 'action'}
      ],
      sms: [],
      dialog: false,
      files: []
    }
  },
  methods: {
    showModal() {
      this.dialog = true;
    },
    uploadContacts() {
      let dataForm = new FormData();
      dataForm.append('file', this.files);
      const config = {
        headers: {
          'content-type': 'multipart/form-data'
        }
      }
      httpClient.post('importContacts', dataForm, config).then(res => {
        swal.fire('success', '', 'success');
      }).catch(e => {
        swal.fire('Error', 'Error occurred retry', 'error')
      })
    },
    getSMSCampaigns() {
      getRequest('smsCampaign').then(({data}) => {
        this.sms = data;
      }).catch(e => {
        console.log(e)
      })
    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>